import { AUTONOMY_VENDOR_ID } from '@/console/features/orchestrators/orchestrators.constants';
import {
  TSoftPlcDeviceProps,
  TVplcBinding,
  TVplcBindingState,
} from '@/console/features/orchestrators/utils/vplc-binding.types';
import { ChipStatus } from '@/shared/components/ui/chip/chip.types';
import {
  DeviceTypeEnum,
  HealthStatus,
  OpenPlcVplcFragment,
  ProvisioningState,
  VplcRecordState,
} from '@/shared/types/types.generated';

const CHIP_STATUS: Record<TVplcBindingState, ChipStatus> = {
  running: 'green',
  unhealthy: 'orange',
  // Matches the vPLC list's build chip.
  building: 'yellow',
  failed: 'red',
};

export const isSoftPlcDevice = ({
  vendorId,
  deviceType,
}: TSoftPlcDeviceProps) =>
  vendorId === AUTONOMY_VENDOR_ID && deviceType === DeviceTypeEnum.SoftPlc;

const getBindingState = ({
  provisioningState,
  healthStatus,
  isRunning,
}: OpenPlcVplcFragment): TVplcBindingState | undefined => {
  if (provisioningState === ProvisioningState.Failed) {
    return 'failed';
  }

  if (provisioningState === ProvisioningState.Creating) {
    return 'building';
  }

  if (provisioningState !== ProvisioningState.Ready) {
    return;
  }

  if (healthStatus === HealthStatus.Unhealthy || isRunning === false) {
    return 'unhealthy';
  }

  return 'running';
};

export const getVplcBinding = (vplc: OpenPlcVplcFragment): TVplcBinding => {
  const state = getBindingState(vplc);

  return {
    state,
    chipStatus: state && CHIP_STATUS[state],
    isBindable:
      vplc.recordState === VplcRecordState.Acknowledged &&
      vplc.provisioningState === ProvisioningState.Ready &&
      Boolean(vplc.autonomyId && vplc.ipAddress),
  };
};
